<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <GroupSubscriptionsView
      :fields="fields"
    />
    <UsersTable
      :teamId="teamId"
      :title="$t('users.users')"
      :exclude="true"
      name="included"
      filterField="teams.id"
    />
    <UsersTable
      :teamId="teamId"
      :title="$t('users.users_available_for_team')"
      name="excluded"
      filterField="teams.exclude.id"
    />
  </div>
</template>

<script>
  import fields from './teamsCreationFields.js';
  import GroupSubscriptionsView from './GroupSubscriptionsView'
  import UsersTable from './UsersTable.vue'

  export default {
    name: 'GroupSubscriptionCreation',
    components: {
      GroupSubscriptionsView,
      UsersTable
    },
    computed: {
      teamId () {
        return this.$route.params.id || ''
      }
    },
    data () {
      return {
        fields: fields
      }
    },
    mounted () {
      if(!this.teamId){
        this.$router.push({path: '/groups'})
      }
    }
  }
</script>